import {
    attemptLogin as loginService,
    doLogout as logoutService
} from '@/services/auth'
import * as types from './mutations_types'
import { isEmpty } from 'lodash'

export const attemptLogin = (context, payload) => {
    return loginService(payload)
        .then(response => {
            window.localStorage.setItem('pml_token', response.data.token)
            context.commit(types.SET_TOKEN, response.data.token)
            context.commit(types.SET_SHOW_TOUR, response.data.showTour)
        })
}

export const logout = (context) => {
    const token = window.localStorage.getItem('pml_token')

    if (!isEmpty(token) || !isEmpty(context.getters.getToken)) {
        window.localStorage.removeItem('pml_token')
        logoutService()
    }

    context.dispatch('clearStore')
}

export const clientLogout = (context) => {
    window.localStorage.removeItem('pml_token')
    context.dispatch('clearStore')
}

export const setShowTour = (context, showTour) => {
    context.commit(types.SET_SHOW_TOUR, showTour)
}



// WEBPACK FOOTER //
// ./src/modules/auth/store/actions.js